import http from 'services/http-service';

const VoucherService = {
    Check(voucherCode: string, email: string, programId: string) {
        var response = http.post(`/vouchers/check`, { voucherCode: voucherCode, email: email || "", programId: programId });
        return response;
    }
};

export default VoucherService;